export default "__VITE_ASSET__BYerXx48__"